import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { auth } from '../../integrations/Firebase';
import { Helmet } from "react-helmet-async";
import { Navbar, Footer, Breadcrumbs } from "../../components/shared";
import useCheckLoggedin from "../../utils/useCheckLoggedin";
import { notifyMobileLinked, checkMobileEligibility } from "../../service/UserApi";
import { useSelector } from "react-redux";


const UserMobileVerification = () => {
  useCheckLoggedin(); // Check if the user is logged in (if no user data, redirect to login)
  const [mobileLinked, setMobileLinked] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [isOtpSent, setIsOtpSent] = useState(false);
  const navigate = useNavigate();
  const { register, handleSubmit, formState: { errors }, reset } = useForm();
  //const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));
  const loggedInUserEmail = useSelector((state) => state.user.email);


  const handleMobileSubmit = async (data) => {
    const { mobile } = data;
    setLoading(true);
    setError("");

    try {
      const checkMobileEligibilitydata = { email: loggedInUserEmail, mobile: mobile }
      const checkMobileEligibilityResponse = await checkMobileEligibility(checkMobileEligibilitydata); // Await the fetchFamilyById function
      if (checkMobileEligibilityResponse && !checkMobileEligibilityResponse.success) {
        if (checkMobileEligibilityResponse.message && checkMobileEligibilityResponse.message === 'User does not exists') {
          alert("பயனர் கிடைக்கவில்லை, மீண்டும் உள்நுழையவும்...");
          navigate(`/auth/login`);
        }

        if (checkMobileEligibilityResponse.message && checkMobileEligibilityResponse.message === 'Mobile number already linked') {
          alert("இந்தக் கணக்குடன் ஏற்கனவே ஒரு தொலைபேசி எண் இணைக்கப்பட்டுள்ளது.");
          navigate(`/user/profile?fromMobileVerification=true`);
          return;
        }
        if (checkMobileEligibilityResponse.message && checkMobileEligibilityResponse.message === 'Mobile number already linked to another email') {
          alert('இந்த தொலைபேசி எண் மொபைல் எண் ஏற்கனவே ' + checkMobileEligibilityResponse.linkedEmail + ' மின்னஞ்சலுடன் இணைக்கப்பட்டுள்ளது.');
          navigate(`/`);
          return;
        }
        if (checkMobileEligibilityResponse.message && checkMobileEligibilityResponse.message === 'OTP limit exceeded for today. Try again tomorrow.') {
          alert("இன்றைக்கான OTP வரம்பை மீறிவிட்டீர்கள். நாளை மீண்டும் முயற்சிக்கவும்...");
          navigate(`/`);
          return;
        }
        alert("இந்தக் கணக்குடன் தொலைபேசி எண் இணைப்பதில் பிழை, தயவுசெய்து பின்னர் முயற்சிக்கவும்.");
        navigate(`/`);
        return;
      }
      const phoneNumber = `+91${mobile}`;
      if (checkMobileEligibilityResponse && checkMobileEligibilityResponse.success) {
        setMobileLinked(phoneNumber);
        setIsOtpSent(true);
        reset(); // Clear the form after mobile number submission
        setTimeout(() => {
          setLoading(false);
        }, 2000); // Simulate a delay
      }
    } catch (err) {
      console.error("Full Error:", err);
      alert(`OTP அனுப்புவதில் பிழை, தயவுசெய்து பின்னர் முயற்சிக்கவும்.`);
    } finally {
      setLoading(false);
    }
  };

  const handleOtpSubmit = async (data) => {
    const { otp } = data;
    setLoading(true);
    setError("");
    try {
      const user = auth.currentUser;
      if (user) {
        // Attempt to link the phone number with the current account
        try {
          const notifydata = { email: loggedInUserEmail, mobileLinked, otp }
          const notifyResponse = await notifyMobileLinked(notifydata);
          if (notifyResponse && notifyResponse.success) {
            navigate(`/user/profile?fromMobileVerification=true`);
          }

          if (notifyResponse && !notifyResponse.success) {
            if (notifyResponse.message) {
              if (notifyResponse.message === 'OTP தவறானது. மீண்டும் முயற்சிக்கவும்.') {
                //                alert(notifyResponse.message);
                setError(notifyResponse.message);
                return;
              }
              alert(notifyResponse.message);
              navigate(`/user/profile`);
              return;
            }
            alert("இந்தக் கணக்குடன் தொலைபேசி எண் இணைப்பதில் பிழை, தயவுசெய்து பின்னர் முயற்சிக்கவும்.");
            navigate(`/`);
            return;
          }
        } catch (err) {


          alert("தொலைபேசி எண்ணை இணைப்பதில் பிழை. மீண்டும் முயற்சிக்கவும்.");
          console.error(`Error linking phone number: ${err.message}`);
          navigate(`/user/profile?fromMobileVerification=true`);

        }
      } else {
        alert("பயனர் அங்கீகரிக்கப்படவில்லை.");
        navigate("/auth/login"); // Redirect to login if no user data is found
      }
    } catch (err) {
      console.error("Error verifying OTP:", err);
      alert(`தவறான OTP, தயவுசெய்து மீண்டும் முயற்சிக்கவும்.`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Navbar />
      <Helmet>
        <title>ஸ்ரீ பொன்னாச்சி அம்மன் திருக்கோவில்கள் | கைபேசி எண் சரிபார்க்கவும்</title>
        <link rel="canonical" href="/user/mobile-verification" />
      </Helmet>
      <div className="general_parent">
        <div className="general_container">
          <div className="general_body">
            <Breadcrumbs /><br />
            {!isOtpSent ? (
              <form onSubmit={handleSubmit(handleMobileSubmit)} className="auth_form">
                <div className="auth_element">
                  <label className="auth_label">📱 கைபேசி எண்: (10 இலக்க இந்திய எண்கள் மட்டும்)</label>
                  <input
                    type="text"
                    {...register("mobile", {
                      required: "கைபேசி எண் தேவை.",
                      pattern: {
                        value: /^[0-9]{10}$/,
                        message: "தயவுசெய்து செல்லுபடியாகும் 10 இலக்க மொபைல் எண்ணை உள்ளிடவும்.",
                      },
                    })}
                    className="auth_input"
                    placeholder="உதாரணம்: 1234567890"
                    autoComplete="off"
                    inputMode="numeric"
                    maxLength="10"
                  />
                  {errors.mobile && <div className="auth_error">{errors.mobile.message}</div>}
                  {error && <div className="auth_error">{error}</div>}
                </div>

                <div id="recaptcha-container"></div>
                <button type="submit" className="auth_submit" disabled={loading}>
                  {loading ? "சமர்ப்பிக்கின்றது..." : "OTP அனுப்பவும்"}
                </button>
              </form>
            ) : (
              <form onSubmit={handleSubmit(handleOtpSubmit)} className="auth_form">
                <div className="auth_element">
                  <label className="auth_label">🔐 OTP</label>
                  <input
                    type="text"
                    {...register("otp", {
                      required: "OTP தேவை",
                      pattern: {
                        value: /^[0-9]{6}$/,
                        message: "OTP 6 இலக்கங்களாக இருக்க வேண்டும்.",
                      },
                    })}
                    className="auth_input"
                    autoComplete="one-time-code"
                    maxLength="6"
                    autoCapitalize="off"
                    autoCorrect="off"
                    inputMode="numeric"
                  />
                  {errors.otp && <div className="auth_error">{errors.otp.message}</div>}
                  {error && <div className="auth_error">{error}</div>}
                </div>
                <button type="submit" className="auth_submit" disabled={loading}>
                  {loading ? "சமர்ப்பிக்கின்றது..." : "OTP சரிபார்க்கவும்"}
                </button>
              </form>
            )}
            <br />
            <button onClick={() => navigate("/user/profile")}>என் கணக்கிற்குச் செல் 👤</button>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default UserMobileVerification;
